/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

export default {
  apiKey: "AIzaSyDVFUoLOhuifkDrXGy02_qTBRPQXxNKJz4",
  authDomain: "arrisalah-d7468.firebaseapp.com",
  databaseURL: "https://arrisalah-d7468.firebaseio.com",
  projectId: "arrisalah-d7468",
  storageBucket: "",
  messagingSenderId: "928031098485",
  appId: "1:928031098485:web:cdf773a645ce2089"
};

/*const db    = firebase.firestore();
const auth  = firebase.auth(); 
const currentUser = auth.currentUser;

// date issue fix according to firebase
/*const settings = {
    timestampsInSnapshots: true
}
db.settings(settings)/

// firebase collections
const usersCollection = db.collection('users');

export {
    db,
    auth,
    currentUser,
    usersCollection,   
};*/